import React from 'react';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';

function AddUserButton({ onClick, loading, disabled }) {
    const { t } = useTranslation();

    return (
        <LoadingButton
            disabled={disabled}
            variant="contained"
            startIcon={<PersonAddAltIcon />}
            onClick={onClick}
            loading={loading}
        >
            {t('users.add')}
        </LoadingButton>
    );
}

export default AddUserButton;
